import router from './router'
import store from './store'

router.beforeEach(async (to,from,next) => {
  // 每次打开应用时检查是否有存储的登录信息
  let admintoken = localStorage.getItem('ats_admintoken')
  if(admintoken){
    if (to.name === 'Login') {
        next('/')
    } else {
      let userinfo = store.state.userinfo
      if(userinfo.access===undefined){
        userinfo = await store.dispatch('getUserinfo')
      }
      if(to.name==='404' || to.name==='AccessDeny' || to.name==='dashboard'){
        next()
      } else {
        if(store.state.loginStatus===false){
          localStorage.removeItem('ats_admintoken')
          next('/login')
        }else{
          if(userinfo.access!='all'){
            let access_arr = userinfo.access.checkedKeys.concat(userinfo.access.harfCheckedKeys)
            if(-1 == access_arr.indexOf(to.meta.access)){
              next('/access_deny')
            }else{
              next()
            }
          }else{
            next()
          }
        }
      }
    }
  } else {
    if (to.name === 'Login') {
      next()
    } else {
      next(`/login?redirect=${to.path}`)
    }
  }
})
